import { RefObject } from "react";
// eslint-disable-next-line no-restricted-imports
import {
  RippleOptions,
  useRipple as originalUseRipple,
} from "react-use-ripple";

const useRipple = (
  ref: RefObject<HTMLElement>,
  options?: RippleOptions
): void => {
  originalUseRipple(ref, {
    rippleColor: "rgba(200,200,200,0.2)",
    animationLength: 500,
    ...options,
  });
};

export default useRipple;
